// Central contact / social configuration used across Navbar, Footer and the Contact page.
export const CONTACT = {
  email: "sommetuhrenwerke@gmail.com",
  emailHref: "mailto:sommetuhrenwerke@gmail.com",
  whatsappDisplay: "076 702 17 77",
  whatsappHref: "https://wa.me/41767021777",
  instagramHandle: "@sommet.offiziell",
  instagramHref: "https://www.instagram.com/sommet.offiziell",
  tiktokHandle: "@Sommet.uhrenwerke",
  tiktokHref: "https://www.tiktok.com/@sommet.uhrenwerke",
};
